import { Link } from 'react-router-dom'
import './MakeYourOwnToy.css'

type MakerToy = {
  id: string
  title: string
  path: string
}

const MAKER_TOYS: MakerToy[] = [
  { id: 'music-player', title: 'Music Player', path: '/make/music-player' },
  { id: 'abc', title: 'ABC', path: '/make/abc' },
  { id: 'midi-synth', title: 'MIDI Synth', path: '/make/midi-synth' },
  { id: 'podcast-player', title: 'Podcast Player', path: '/make/podcast-player' },
]

export default function MakeYourOwnToy() {
  return (
    <section className="make-your-own-toy">
      <h2>
        Make your own <em className="wink">toy</em>.
      </h2>
      <ul className="make-your-own-toy__strip" aria-label="Make your own toy">
        {MAKER_TOYS.map((toy) => (
          <li key={toy.id} className="make-your-own-toy__card">
            <Link to={toy.path} className="make-your-own-toy__link">
              <div className="make-your-own-toy__art" aria-hidden="true">
                {toy.title.charAt(0)}
              </div>
              <h3 className="make-your-own-toy__title">{toy.title}</h3>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
